module.exports = __webpack_public_path__ + "img/la.f74e9f12.jpg";